/* eslint-disable no-underscore-dangle, global-require */

let MCDProductPagePostcodeUI;

const LocationService = require('../locationservice');
const UILocationSearch = require('./locationsearch');
const UIProgressMeter = require('./progressmeter');

function UIProductAvailability(automatic) {

  const deviceType = window.App.Platform.isDesktop() ? '.desktop' : '.touch';
  this.__deliveryOptions = document.querySelector(`${deviceType} .check-delivery-options`);

  // init MCD postcode check only if location search is enabled for the product page
  if ($('[data-anonid=location-search-block]:visible').length > 0) {
    if (window.App.Platform.isDesktop()) {
      MCDProductPagePostcodeUI = require('../mcd-postcode-check-desktop.js');
    } else {
      MCDProductPagePostcodeUI = require('../mcd-postcode-check-touch.js');
    }

    MCDProductPagePostcodeUI.init();
  }

  if (!this.__deliveryOptions) {
    // Do not initialize UIProductAvailability if product is out of stock
    console.log('UIProductAvailability: no delivery options, cannot initialize');
    return;
  }

  // Nodelist because of the duplicate content hack for mobile/desktop layouts
  const nodeList = document.querySelectorAll("[data-component='locationsearch']");
  if (nodeList.length > 0) {
    for (let i = 0; i < nodeList.length; i++) {
      const locationSearch = new UILocationSearch(nodeList[i]);
      locationSearch.setUseCase('Product page', 'MCD section');
    }
  }

  LocationService.changeLocation = this.changeLocation.bind(this);
  LocationService.addEventListener('clearlocation', this.onclearlocation.bind(this), false);

  if (automatic) {
    this.__deliveryOptions.setAttribute('hidden', true);
    this.__progressMeter = new UIProgressMeter();
    this.__progressMeter.setLabel('Checking...');
    this.__deliveryOptions.parentNode.appendChild(this.__progressMeter.getHostElement());
    this.onlocationstatechange = this.onlocationstatechange.bind(this);
    LocationService.addEventListener('locationstatechange', this.onlocationstatechange, false);
  }
}
UIProductAvailability.prototype = {
  /** @returns {void} */
  onready: function() {
    LocationService.removeEventListener('locationstatechange', this.onlocationstatechange, false);
    if (this.__progressMeter && this.__deliveryOptions) {
      $(this.__progressMeter.getHostElement()).remove();
      this.__deliveryOptions.removeAttribute('hidden');
    }
  },

  /** @param {LocationDescriptor} location
        @param {Promise} cancellable
        @returns {Promise} */
  changeLocation: function(location, cancellable) {
    if (MCDProductPagePostcodeUI) {
      return MCDProductPagePostcodeUI.getProductAvailability(location, cancellable);
    }
    return () => {};
  },

  /** @returns {void} */
  onclearlocation: function() {
    if (MCDProductPagePostcodeUI) {
      MCDProductPagePostcodeUI.clearProductAvailability();
    }
  },

  /** @returns {void}
        @param {Event} event */
  onlocationstatechange: function(event) {
    const state = event.detail.status;
    switch (state) {
      case LocationService.LocationState.LOADED:
        this.onready();
        break;
      case LocationService.LocationState.INVALID:
      case LocationService.LocationState.ERROR:
      case LocationService.LocationState.TIMEOUT:
      case LocationService.LocationState.FAILED:
      case LocationService.LocationState.COMPLETE:
        this.onready();
        break;
      default:
        break;
    }
  },

  /**
     * setProductAvailability
     * @param productAvailability
     */
  setAvailability: function setAvailability(productAvailability) {
    if (MCDProductPagePostcodeUI) {
      MCDProductPagePostcodeUI.setLocationFeedback(productAvailability);
    }
    this.onready();
  }
};

module.exports = UIProductAvailability;
